export default __webpack_public_path__ + "static/media/icon-info-outline.3c85b558.svg";